// One quiet banner above a long round: a lot of older mail in the inbox, so Fresh start
// (docs/design/fresh-start.md) is offered first. The server says whether there is a reason
// (enough older mail, no Fresh start in the last 30 days); "Not now" quiets it for a week on this
// device. Renders nothing until then. No animation, never red, never "overdue".
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { freshStartNudgeQuery } from "@web/recent/recentApi";
import { Button } from "@web/ui/Button";
import { SoftBanner } from "@web/ui/SoftBanner";
import {
  freshStartNudgeWords,
  isNudgeDismissed,
  readNudgeDismissedAt,
  recordNudgeDismissed,
} from "./freshStartNudgeWords";

const LINK_CLASS =
  "inline-flex h-8 shrink-0 items-center justify-center rounded-lg border border-transparent bg-accent px-3 text-sm font-medium whitespace-nowrap text-accent-ink transition-colors hover:brightness-105 active:brightness-95";

/** `feedId` is accepted for the mount point; the recommendation covers the whole inbox. */
export function FreshStartNudge(_props: { feedId?: string | null }) {
  const nudge = useQuery(freshStartNudgeQuery);
  const [dismissed, setDismissed] = useState(() =>
    isNudgeDismissed(readNudgeDismissedAt(), Date.now()),
  );
  const data = nudge.data;
  if (!data?.suggested || dismissed) return null;

  const notNow = () => {
    recordNudgeDismissed(Date.now());
    setDismissed(true);
  };

  return (
    <SoftBanner className="mx-4 mt-3 md:mx-5">
      <p>{freshStartNudgeWords(data.olderThanMonth)}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <Link to="/fresh-start" className={LINK_CLASS}>
          Archive older mail
        </Link>
        <Button variant="ghost" size="sm" onClick={notNow}>
          Not now
        </Button>
      </div>
    </SoftBanner>
  );
}
